export var entityTypeNameFor = function entityTypeNameFor(entity) {
  var schema = entity && entity._schema || {};
  return (schema.entityTypeName || entity && entity.__typename || 'entity').replace(/Platform\_/, '');
};